import { render, staticRenderFns } from "./StoredPoints.vue?vue&type=template&id=1de196c0"
import script from "./StoredPoints.vue?vue&type=script&lang=js"
export * from "./StoredPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de196c0')) {
      api.createRecord('1de196c0', component.options)
    } else {
      api.reload('1de196c0', component.options)
    }
    module.hot.accept("./StoredPoints.vue?vue&type=template&id=1de196c0", function () {
      api.rerender('1de196c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/StoredPoints.vue"
export default component.exports